import { render } from "./PrintBox.vue?vue&type=template&id=472d31cf&scoped=true"
import script from "./PrintBox.vue?vue&type=script&lang=js"
export * from "./PrintBox.vue?vue&type=script&lang=js"

import "./PrintBox.vue?vue&type=style&index=0&id=472d31cf&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472d31cf"]])

export default __exports__